import { createColorTransform, perceptualDistance } from '@limonade/color-science';
/** RGB working samples stay in their declared domain; distance always uses OKLab. */
export function createPerceptualMetric(workingSpace) {
    if (workingSpace === 'sRGB' || workingSpace === 'OKLab-analysis-from-sRGB')
        return perceptualDistance;
    // Reuse CMF's compiled transform, never interpret P3/709/ACEScg as sRGB bytes.
    // This remains the SDK's bounded SDR analysis metric, not an HDR/gamut solve.
    const display = createColorTransform({ from: workingSpace, to: 'sRGB' });
    return (first, second) => perceptualDistance(display.rgb(first), display.rgb(second));
}
export function createWorkingTransforms(options, spaces) {
    const to = spaces.workingColorSpace === 'OKLab-analysis-from-sRGB' ? 'sRGB' : spaces.workingColorSpace;
    const transform = (from, inputTransferFunction) => from === to && !inputTransferFunction
        ? undefined : createColorTransform({ from, to, inputTransferFunction });
    const reference = transform(spaces.referenceInputColorSpace, options?.referenceInputTransferFunction);
    const source = transform(spaces.sourceInputColorSpace, options?.sourceInputTransferFunction);
    return { reference, source, warnings: [...(reference?.warnings ?? []), ...(source?.warnings ?? [])] };
}
//# sourceMappingURL=colorAnalysis.js.map